<div class="floor">
    <p class="floor_title">Étage</p>
    <div class="floor_items">
        <p
                [class.selected_floor]="(floorService.selectedFloor | async) === floor"
                *ngFor="let floor of floors"
                (click)="selectFloor(floor)"
        >{{ floor }}</p>
    </div>
</div>
